export default {
  landingPageNoProductsSoldesButton: {
    id: 'landing_page_no_products_soldes_button',
    defaultMessage: 'You can also check out our Best Deals.',
  },
}
